import Vue from 'vue'
import Vuex from 'vuex'
import {
  getIndexContentApi
} from "../utils/common"
import {
  routes
} from "../router"
import {resetRouter} from "../router"
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    menuCodes: [],
    routes: [],
  },
  mutations: {
    SET_MENUCODES: (state, data) => {
      state.menuCodes = data;
    },
    SET_ROUTES: (state, data) => {
      state.routes = data;
    },
  },
  actions: {
    getIndexContent({
      commit,
      state
    }) {
      return new Promise((resolve, reject) => {
        getIndexContentApi().then(response => {
            const {
              data
            } = response;
            if (!data) {
              reject();
            }
            commit('SET_MENUCODES', data.menuCodes)
            resolve(data.menuCodes);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    generateRoutes({
      commit
    }, val) {
      return new Promise(resolve => {
        let authRoutes = [];
        let authCodes = Object.keys(val.menuCodes)
        routes.forEach((e, i) => {
          if (authCodes.indexOf(e.meta.code) > -1||e.meta.hidden) {
            let childrenData = e.children ? e.children.filter(t => {
              return authCodes.indexOf(t.meta.code) > -1 || !t.meta.code;
            }) : [];
            if(childrenData.length>0){
              childrenData.forEach(s=>{
                s.meta.title=val.menuCodes[s.meta.code]
              })
              // debugger
              e.meta.redirect=e.path+'/'+childrenData[0].path
            }
            e.meta.title=val.menuCodes[e.meta.code]?val.menuCodes[e.meta.code]:e.meta.title
            authRoutes.push({
              ...e,
              children: childrenData
            })

          }
        })
        commit("SET_ROUTES", authRoutes);
        resolve(authRoutes);
      });
    }
  },
  modules: {}
})